import { render, staticRenderFns } from "./CommercantContent.vue?vue&type=template&id=ae2aa78a&scoped=true&"
import script from "./CommercantContent.vue?vue&type=script&lang=js&"
export * from "./CommercantContent.vue?vue&type=script&lang=js&"
import style0 from "./CommercantContent.vue?vue&type=style&index=0&id=ae2aa78a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2aa78a",
  null
  
)

export default component.exports